import { render, staticRenderFns } from "./CommentIndicator.vue?vue&type=template&id=8a979064&scoped=true&"
import script from "./CommentIndicator.vue?vue&type=script&lang=js&"
export * from "./CommentIndicator.vue?vue&type=script&lang=js&"
import style0 from "./CommentIndicator.vue?vue&type=style&index=0&id=8a979064&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a979064",
  null
  
)

export default component.exports